// extracted by mini-css-extract-plugin
module.exports = {"root":"SeoPagination_root__C_qy6","link":"SeoPagination_link__h3V4M","active":"SeoPagination_active__biTjm","ellipsis":"SeoPagination_ellipsis___IXyY"};